// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__346Va","boxTitle":"Qualiphy_boxTitle__Jz1x2","box":"Qualiphy_box__AczBV","toggleWrap":"Qualiphy_toggleWrap__2dbAc"};